<template>
  <v-container fluid>
    <v-row>
      <v-col xs12 md6 offset-md3>
        <v-card>
          <v-toolbar>
            <v-toolbar-title>登入</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              label="帳號"
              v-model="account"
              class="mt-5 input-group"
              required
            />
            <v-text-field
              label="請輸入密碼"
              hint=""
              v-model="password"
              type="password"
              class="input-group"
              required
            />

            <v-checkbox
              label="新北市親師生平台登入"
              v-model="checkbox"
            ></v-checkbox>

            <v-container fluid="fluid">
              <v-row>
                <v-col xs6>
                  <small>*必填欄位</small>
                </v-col>
                <v-col xs6 class="text-sm-right">
                  <v-btn light flat router href="/forgot_password">忘記密碼？</v-btn>
                </v-col>
              </v-row>
            </v-container>

            <v-card-row actions class="mt-4">
              <v-btn small primary dark v-on:click.native="validation()">登入</v-btn>
            </v-card-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapMutations, mapActions } from 'vuex'

  export default {

    name: 'Login',

    data () {
      return {
        account: '',
        password: '',
        checkbox: false,
        redirect: '/'
      }
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '登入',
        link: '/login'
      })

      if (this.$route.query && this.$route.query.ref) {
        this.redirect = this.$route.query.ref
      }
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb',
        'setErrorMessage'
      ]),

      ...mapActions([
        'login'
      ]),

      dologin () {
        var self = this
        this.login({
          account: this.account,
          password: this.password,
          provider: this.checkbox === true ? 'NtpcEdu' : 'LiveABC'
        })
        .then(() => {
          if (self.authorized) {
            self.$router.push(self.redirect)
          }
        })
      },

      validation () {
        if (this.account === '' || this.password === '') {
          this.setErrorMessage('請輸入必填欄位')
          window.document.body.scrollTop = 0
        } else {
          this.dologin()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?12f305d8